import { createFileRoute } from '@tanstack/react-router';

import HomePage from '@src/pages/Home';

export const Route = createFileRoute('/index/home')({
  component: HomePage,
});
